import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

/**
 * PrivateRoute - A component that controls access to protected routes
 * Uses a direct localStorage check as the primary authentication method
 * Falls back to context auth state if needed
 */
const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  const [checkCompleted, setCheckCompleted] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  
  // On mount or route change, do a direct localStorage check first
  useEffect(() => {
    console.log('PrivateRoute: Running auth check for path:', location.pathname);
    
    // Check localStorage directly
    const token = localStorage.getItem('token');
    
    // If we have a token, consider authorized
    if (token) {
      console.log('PrivateRoute: Token found in localStorage, authorizing');
      setIsAuthorized(true);
      setCheckCompleted(true);
      return;
    }
    
    // No token in localStorage, fall back to context
    console.log('PrivateRoute: No token in localStorage, checking context auth state');
    setIsAuthorized(isAuthenticated);
    setCheckCompleted(true);
  }, [location.pathname, isAuthenticated]);

  // While checking auth, show loading
  if (!checkCompleted) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen">
        <div className="mb-4">Verifying access...</div>
        <LoadingSpinner />
      </div>
    );
  }

  // If authorized, render the route
  if (isAuthorized) {
    return children;
  }
  
  // Not authorized, redirect to login
  console.log('PrivateRoute: Access denied, redirecting to login');
  return <Navigate to="/auth/login" state={{ from: location }} replace />;
};

export default PrivateRoute;